
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collectors",
      function () {
        return require("private-next-pages/collectors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collectors"])
      });
    }
  